import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import {
  defaultValueCamerasFilter,
  defaultValueCamerasFilterIProps,
} from "./options";
import Modal from "~/shared/ui/Fields/Modal";
import HistoryCamerasForm from "./HistoryCamerasForm";
import s from "./HistoryCamerasFilter.less";

interface HistoryCamerasFilterIProps {
  openModal?: string;
  initialValues: defaultValueCamerasFilterIProps;
  getIvideonHistoryCameras: (data: defaultValueCamerasFilterIProps) => void;
}

const HistoryCamerasFilter = ({
  openModal,
  initialValues,
  getIvideonHistoryCameras,
}: HistoryCamerasFilterIProps) => {
  const setURLParams = useURLParamsSetter();
  const { handleSubmit, control, reset } =
    useForm<defaultValueCamerasFilterIProps>({
      defaultValues: initialValues,
    });

  const closeModal = () => {
    setURLParams({ openModal: "" });
  };

  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  const resetFilter = () => {
    reset(defaultValueCamerasFilter);
  };

  const submit = (data: defaultValueCamerasFilterIProps) => {
    getIvideonHistoryCameras(data);
    closeModal();
  };

  return (
    <Modal
      customClassName={s.modalStyle}
      isOpen={!!openModal}
      title="Фильтры"
      withCloseBtn={false}
    >
      <HistoryCamerasForm
        closeModal={closeModal}
        control={control}
        onSubmit={handleSubmit(submit)}
        resetFilter={resetFilter}
      />
    </Modal>
  );
};

export default HistoryCamerasFilter;
